import { render, staticRenderFns } from "./FaqNew.vue?vue&type=template&id=3a24868a&"
import script from "./FaqNew.vue?vue&type=script&lang=js&"
export * from "./FaqNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3a24868a', component.options)
    } else {
      api.reload('3a24868a', component.options)
    }
    module.hot.accept("./FaqNew.vue?vue&type=template&id=3a24868a&", function () {
      api.rerender('3a24868a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/FaqNew.vue"
export default component.exports